module.exports = __webpack_public_path__ + "img/img_pt.29c26c52.png";